function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import Button from '@engine/components/presentational/base/button';
import Drawer from '@engine/components/presentational/base/drawer';
import Error from '@engine/components/presentational/base/error';
import Loader from '@engine/components/presentational/base/loader';
import Portal from '@engine/components/presentational/base/portal';
import React from 'react';
import Tree from '@engine/components/presentational/base/tree';

var TreeDrawer = /*#__PURE__*/function (_React$Component) {
  _inherits(TreeDrawer, _React$Component);

  var _super = _createSuper(TreeDrawer);

  function TreeDrawer() {
    _classCallCheck(this, TreeDrawer);

    return _super.apply(this, arguments);
  }

  _createClass(TreeDrawer, [{
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, React.createElement(Portal, null, React.createElement(Drawer, {
        open: this.props.open
      }, React.createElement("div", {
        className: "navbar navbar-default navbar-static-top box-shadow"
      }, React.createElement("div", {
        className: "navbar-brand ml-0 mb-0 mt-0 pull-left"
      }, React.createElement(Button, {
        className: "-mt-5",
        icon: "chevron-right",
        onClick: this.props.close
      })), React.createElement("h4", {
        className: "navbar-brand ml-0 mb-0 mt-0"
      }, this.props.title), React.createElement("div", {
        className: "navbar-brand ml-0 mb-0 mt-0 pull-right"
      }, React.createElement(Button, {
        className: "-mt-5",
        size: "sm",
        icon: "refresh",
        onClick: this.props.refresh
      }))), React.createElement("div", {
        className: "genesis-drawer-body"
      }, React.createElement("div", {
        className: "row"
      }, this.props.error ? React.createElement("div", {
        className: "col-lg-12"
      }, React.createElement(Error, null, this.errorMessage, React.createElement(Button, {
        type: "danger",
        className: "pull-right",
        size: "sm",
        onClick: this.props.refresh
      }, this.errorButtonText))) : '', this.props.loaded ? React.createElement(Tree, {
        data: this.props.data
      }) : React.createElement(Loader, {
        color: "refined-blue",
        position: "absolute-center",
        message: this.loaderMessage
      }))))));
    }
  }, {
    key: "errorMessage",
    get: function get() {
      return [I18n.t('javascript.errors.unable_to_process_request'), I18n.t('javascript.errors.try_again_later')].join(' ');
    }
  }, {
    key: "errorButtonText",
    get: function get() {
      return I18n.t('javascript.actions.try_again');
    }
  }, {
    key: "loaderMessage",
    get: function get() {
      return I18n.t('javascript.status.loading');
    }
  }]);

  return TreeDrawer;
}(React.Component);

export default TreeDrawer;